export const SHOW_PLURALIZED_LABELS = true;

export const TEST_ID = 'maintenancePage';
